import React from 'react';
import { Box, Paper } from '@mui/material';
import { WorkersTable } from '../components/Worker/WorkersTable';

export const ResourcesPage: React.FC = () => {
  return (
    <Box sx={{ flex: 1, p: { xs: 2, sm: 3 }, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
      <Paper elevation={0} sx={{ flex: 1, p: { xs: 2, sm: 3 }, display: 'flex', flexDirection: 'column' }}>
        <WorkersTable />
      </Paper>
    </Box>
  );
};
